<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'userDetailDialog',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-user-detail-dialog'" :title="'用户信息'" :width="state.dialog.width"
    :ok-text="state.dialog.submitTxt" :cancel-button-props="{ style: { display: 'none' } }" @ok="closeDialog"
    @cancel="closeDialog" :maskClosable="false" :keyboard="false" :closable="false">
    <div class="form-content">
      <div class="detail-section first-section">
        <div class="user-header">
          <div class="avatar-block">
            <img :src="avatarSrc" class="avatar-img" @error="onImgError" />
          </div>
          <div class="user-name">微信昵称：{{ state.info.nickname || state.info.nickName || '-' }}</div>
        </div>
        <a-row :gutter="[0, 20]" class="detail-grid">
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">用户ID：</span>
              <span class="detail-value">{{ state.info.userNumber || state.info.id || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">手机号：</span>
              <span class="detail-value">{{ state.info.tel || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">生日：</span>
              <span class="detail-value">{{ state.info.birthDay || '' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">性别：</span>
              <span class="detail-value">
                {{ state.info.gender === '1' ? '男' : state.info.gender === '2' ? '女' : '' }}
              </span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">创建时间：</span>
              <span class="detail-value">{{ state.info.createTime || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">状态：</span>
              <span class="detail-value">{{ state.info.freeze == '0' ? '禁用' : '正常' }}</span>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="userDetailDialog">
import { reactive, ref, computed } from 'vue'
import { useUser } from '@/store/user'
import { message } from 'ant-design-vue'
import defaultAvatar from '@/assets/picLogo.png'

const userStore = useUser()

const state = reactive({
  dialog: {
    visible: false,
    title: '用户信息',
    submitTxt: '关闭',
    width: '580px'
  },
  info: {} as any
})

const imgError = ref(false)

const onImgError = () => {
  imgError.value = true
}

const avatarSrc = computed(() => {
  const pic = state.info.avatar || state.info.pic
  if (pic && /^https?:\/\//i.test(pic)) {
    return pic
  }
  return defaultAvatar
})

const openDialog = async (row: any) => {
  if (!row?.id) return
  imgError.value = false
  try {
    const data: any = await userStore.getUserDetail(row.id)
    // 以列表页数据为基础，详情接口补充；保证用户ID、创建时间和列表一致
    state.info = { ...row, ...(data || {}) }
    state.dialog.visible = true
  } catch {
    state.info = row || {}
    message.error('获取用户信息失败')
  }
}

const closeDialog = () => {
  state.dialog.visible = false
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
@content-padding-x: 30px;
@detail-indent: 13px;

.form-content {
  padding: 24px @content-padding-x 16px;
}

.detail-section {
  &+.detail-section {
    margin-top: 32px;
  }

  &.first-section {
    margin-top: 0;
  }
}

.user-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;

  .avatar-block {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
  }

  .avatar-img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }

  .user-name {
    font-size: 14px;
    color: #222;
  }
}

.detail-grid {
  .detail-item {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 1.5;

    .detail-label {
      flex-shrink: 0;
      text-align: right;
      color: #5c5757;
    }

    .detail-value {
      flex: 1;
      word-break: break-all;
      color: #222;
    }
  }
}

:global(.wrap-user-detail-dialog .ant-modal-body) {
  padding: 0;
  border-radius: 4px;
}

:global(.wrap-user-detail-dialog .ant-modal-content) {
  padding-bottom: 0;
}

:global(.wrap-user-detail-dialog .ant-modal-footer) {
  padding: 22px @content-padding-x 24px;
  text-align: center;
  border-top: none;
}

:global(.wrap-user-detail-dialog .ant-modal-footer .ant-btn-primary) {
  background: #0B0B0B !important;
  border-color: #0B0B0B !important;
}

:global(.wrap-user-detail-dialog .ant-modal-close) {
  display: none;
}
</style>
